import _extends from "@babel/runtime/helpers/extends";
import Container from '../common/Container';
import Version from './Version';
import Size from './Size';
import Downloads from './Downloads';
import { jsx as _jsx } from "react/jsx-runtime";
var Npm = props => /*#__PURE__*/_jsx(Container, _extends({}, props));
Npm.Version = Version;
Npm.Size = Size;
Npm.Downloads = Downloads;
Npm.displayName = 'Npm';
export default Npm;